// JavaScript Document


function initStadortSelect(standortSelect, modal=false) {


    const standorteItems    = standortSelect.querySelectorAll('.dropdown-item');
    const btn               = standortSelect.querySelector('.btn');
    let   btnTitle          = btn.dataset.title;
    const targetListId      = standortSelect.dataset.targetId;

    const initTerm          = standortSelect.dataset.init;

   



    const inputStandort     = document.getElementById('inputStandort');

    const stellenSelectForm = document.querySelector('.stellen-select-form');

    standorteItems.forEach(function(standorteItem){

        standorteItem.addEventListener('click', function(){

            const termId    = this.dataset.termId;

            setVal(termId,this);
            
        });
    });

    function setVal(termId,standorteItem) {
        
        const item = standortSelect.querySelector('[data-term-id="'+termId+'"]');

        if (item) {

            btn.innerHTML   = item.innerHTML;
            const title     = item.getAttribute("title");

            standorteItems.forEach(function(standorteItem){ 
                standorteItem.classList.remove("active");
            })
            item.classList.add("active");

            if (inputStandort) {
                inputStandort.value = title
            }

            // if StellenDropdown and it is hidden, show it
            if (stellenSelectForm && stellenSelectForm.classList.contains('d-none')) {
                stellenSelectForm.classList.remove('d-none');
            }

            const listItems = document.querySelectorAll('#'+targetListId+' .stellen-item');

            const stellenHeading    = document.querySelector('#'+targetListId+' .stellen-heading');
            const stellenNone       = document.querySelectorAll('#'+targetListId+' .stellen-none');

            

            if (modal) {

                formModal.setLangText(termId);


            }

            if (termId === 'all') {

                resetDropdown();
                return false;
            }
            // if form input standort exist, set the value

            //console.log(listItems);
            //stellenHeading
   
            listItems.forEach(function(listItem){



                if (standorteItem && standorteItem.classList.contains('all')) {

                    listItem.classList.remove('d-none');

                } else {

                    listItem.classList.add('d-none');

                    if (listItem.classList.contains('term-'+termId)) {

                        listItem.classList.remove('d-none');

                   }
                }
            });
        }

    }

    function resetDropdown() {

        const listItems = document.querySelectorAll('#'+targetListId+' .stellen-item');


        btnTitle = btn.dataset.title;
        btn.innerHTML = btnTitle;
        standorteItems.forEach(function(standorteItem){ 
            standorteItem.classList.remove("active");
        });
        
        listItems.forEach(function(listItem){
            listItem.classList.remove('d-none');
        });



    }

    if (initTerm) {

        setVal(initTerm);
    }
 
    return {
        setValue:       setVal,
        resetDropdown:  resetDropdown,
    };

}
